<template>
  <div class="interaction">
      <div class="apparel">
        <div class="center">
          <div class="exchange">
            <h2>Human-machine interactions<br /> with smart wearables</h2>
            <p>Internet-of-every-mind embodied by BCI and AI</p>
          </div>
        </div>

      </div>
  </div>
</template>

<script>
export default {
  name: "interaction.vue"
}
</script>

<style scoped>

.interaction {
}

 .apparel {
  margin: 0 auto;
  background-image:url("../../../assets/intellect-img.jpg");
  background-repeat:no-repeat;
  height:900px;
}

 .apparel .center {
   display: flex;
   justify-content: flex-end;
   margin: 0 auto;
   width: 1200px;
 }

 .apparel .exchange {
   padding-top: 415px
}

 .apparel .exchange h2{
   font-style: normal;
   font-weight: 700;
   font-size: 46px;
   line-height: 80px;
   color: #111111;
}

.apparel .exchange p{
  margin-top: 50px;
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 50px;
  color: #999999;
}

</style>
